module.exports = __webpack_public_path__ + "media/photo/electric_servic-395b9554.png";